export const TOGGLE_REGROUPEMENTS_EDIT_MODE = 'TOGGLE_REGROUPEMENTS_EDIT_MODE'
